/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { profileAction } from "@redux/modules";

// Header - Footer
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';

// Home Components
import HomeBudgetStrip from './HomeBudgetStrip';
import HomeBadgeStrip from './HomeBadgeStrip';
import HomeAnnouncement from './HomeAnnouncement';
import HomeTargets from './HomeTargets';
import HomeProduct from './HomeProduct';
import HomeLeaderboard from './HomeLeaderboard';
import HomeSurvey from './HomeSurvey';
import HomeGames from './HomeGames';

// Hooks
import useRoleAccess from '@hooks/useRoleAccess';

/**
 * Rol açıklamasını (authUser.roleName, ör. "İşletme") sadeleştirir.
 * Bütçe strip'i yalnızca Usta / İşletme segmentine gösterilir.
 */
const normalizeRole = (s) =>
  (s || '')
    .replace(/İ/g, 'I')
    .replace(/ı/g, 'i')
    .replace(/Ş/g, 'S')
    .replace(/ş/g, 's')
    .replace(/Ç/g, 'C')
    .replace(/ç/g, 'c')
    .replace(/Ğ/g, 'G')
    .replace(/ğ/g, 'g')
    .replace(/Ü/g, 'U')
    .replace(/ü/g, 'u')
    .replace(/Ö/g, 'O')
    .replace(/ö/g, 'o')
    .toUpperCase()
    .trim();

/**
 * Home Sayfası
 * 
 * Anasayfa bileşenlerini rol bazlı olarak gösterir.
 * useRoleAccess hook'u ile merkezi erişim kontrolü sağlar.
 */
const Home = () => {
  const dispatch = useDispatch();
  const authUser = useSelector((store) => store.auth);
  const [showLeaderboard, setShowLeaderboard] = useState(false);
  const [showShop, setShowShop] = useState(false);
  const [showGames, setShowGames] = useState(false);
  const [tenantPaths, setTenantPaths] = useState([]);

  // Rol erişim hook'u - merkezi kontrol
  const {
    isComponentActive,
    isCategoryActive,
    activeComponents,
    roleId,
    userRole
  } = useRoleAccess();

  // Bütçe & sayaç strip'i yalnızca İşletme segmentine gösterilir.
  // Usta (rol adı "USER3") segmentine gösterilmez.
  const normalizedRole = normalizeRole(userRole);
  const isUsta =
    normalizedRole.includes('USTA') || normalizedRole.includes('USER3');
  const isBudgetSegment =
    !isUsta &&
    (normalizedRole.includes('ISLETME') ||
      normalizedRole.includes('TEMSILCI'));

  useEffect(() => {
    if (authUser && roleId) {
      dispatch(profileAction.getTenantMenu(roleId)).then(
        (res) => {
          if (res.isHttpSuccess && res.data && Array.isArray(res.data)) {
            const paths = res?.data?.map((item) => item.menu?.pathUrl);
            setTenantPaths(paths);

            if (!paths.includes("/leaderboard")) {
              setShowLeaderboard(true);
            } else {
              setShowLeaderboard(false);
            }
            if (!paths.includes("/shop")) {
              setShowShop(true);
            } else {
              setShowShop(false);
            }
            if (
              paths.includes("/games/find-mate") &&
              paths.includes("/games/word-puzzles") &&
              paths.includes("/games/score-hunt") &&
              paths.includes("/games/guess-picture") &&
              paths.includes("/games/question-wheel") &&
              paths.includes("/games/who-wants-score")
            ) {
              setShowGames(false);
            } else {
              setShowGames(true);
            }
          } else {
            setTenantPaths([]);
            setShowLeaderboard(true);
            setShowShop(true);
            setShowGames(true);
          }
        }
      );
    }
  }, [authUser, roleId]);

  return (
    <div className="page-container">
      <Header />
      <main className="page-content page-content--fill">
        {isBudgetSegment && <HomeBudgetStrip />}

        {activeComponents?.length > 0 && isComponentActive("DUYURU") && <HomeAnnouncement />}
        {activeComponents?.length > 0 && isComponentActive("ROZET") && <HomeBadgeStrip />}
        <HomeTargets />
        {activeComponents?.length > 0 && isComponentActive("ÜRÜNLER") && showShop && <HomeProduct />}
        {activeComponents?.length > 0 && isComponentActive("LİDERLER TABLOSU") && showLeaderboard && <HomeLeaderboard />}
        {activeComponents?.length > 0 && isComponentActive("ANKET") && <HomeSurvey />}
        {activeComponents?.length > 0 && isCategoryActive("OYUNLAR") && showGames && (
          <HomeGames tenantPaths={tenantPaths} />
        )}
      </main>
      <Footer />
    </div>
  );
};

export default Home;
